import React from 'react';
import { capabilities, contact } from '../../content/site';
import { ArrowRight } from '../Common/Icons';

/**
 * The full capability list.
 * `compact` renders titles only — used on the home page, where the detail
 * belongs on the Residential & Commercial page rather than in the overview.
 */
const Capabilities = ({ compact = false, heading, eyebrow = 'Capabilities', lead }) => (
  <section className={`section${compact ? '' : ' section--paper2'}`} id="capabilities">
    <div className="container">
      <div className="section-head section-head--center">
        <p className="eyebrow">{eyebrow}</p>
        <h2>{heading}</h2>
        {lead && <p className="section-head__lead">{lead}</p>}
      </div>

      <div className={`capabilities__grid${compact ? ' capabilities--compact' : ''}`}>
        {capabilities.map((item, i) => (
          <div className="capability" key={item.title}>
            <p className="capability__title">
              <span className="capability__num">{String(i + 1).padStart(2, '0')}</span>
              {item.title}
            </p>
            {!compact && <p className="capability__desc">{item.description}</p>}
          </div>
        ))}

        {/* Squares off the grid at 2, 3 and 4 columns, and gives the list an exit. */}
        <a className="capability capability--cta" href={`mailto:${contact.email}`}>
          <p className="capability__title">Something else?</p>
          <span className="link-arrow">
            Talk to us
            <ArrowRight size={15} />
          </span>
        </a>
      </div>
    </div>
  </section>
);

export default Capabilities;
